import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=29cc1224&"
import script from "./Privileges.vue?vue&type=script&lang=js&"
export * from "./Privileges.vue?vue&type=script&lang=js&"
import style0 from "./Privileges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Privileges.vue"
export default component.exports